// extracted by mini-css-extract-plugin
module.exports = {"planDiscountNotice":"PlanDiscountNotice_planDiscountNotice__X4asZ"};